module.exports = __webpack_public_path__ + "media/images/photo/photo-contact-29cc762f46468e39e176a28ee476e0c8.png";